import React from "react";
import { TextField } from "@mui/material";

export default function Text({ question, value, onChange }: any) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      placeholder={question?.help_text || "Ihre Antwort"}
      value={value || ""}
      onChange={(e) => onChange && onChange(e.target.value)}
      sx={{ marginTop: 1 }}
    />
  );
}
